import React from 'react';
import {Box, Typography, Grid} from '@mui/material';
import IndividualDashboardShell from '../components/IndividualDashboard.comp';
import {NAVY, PageHeader} from '../components/widgets.comp';

const GREEN = '#1B6B55';

const ACTIONS = [
    {
        num: '1',
        title: "Pick one daily 'offline' window",
        body: 'Small, regular breaks build your screen-time self-control — your top area to grow.',
        withText: 'On your own, or with family',
    },
    {
        num: '2',
        title: 'Save two trusted adults to ask for help',
        body: 'Knowing who to tell makes it easier to speak up early. Asking for help is a strength, not a weakness.',
        withText: 'With a parent or teacher',
    },
    {
        num: '3',
        title: 'Use your strengths to help a classmate',
        body: "You're strong at ICT skills and digital empathy — teaching someone else makes you even better.",
        withText: 'With a classmate',
    },
];

const ActionCard = ({num, title, body, withText}) => (
    <Box sx={{
        border: '1px solid var(--brand-border, #E5E7EB)', borderRadius: '12px', backgroundColor: 'var(--brand-surface, #fff)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)', p: 3, height: '100%',
        display: 'flex', flexDirection: 'column',
    }}>
        <Box sx={{
            width: 40, height: 40, borderRadius: '50%', backgroundColor: GREEN,
            display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2,
        }}>
            <Typography sx={{fontSize: '18px', fontWeight: 800, color: '#fff'}}>{num}</Typography>
        </Box>
        <Typography sx={{fontSize: '16px', fontWeight: 700, color: NAVY, mb: 1, lineHeight: 1.3}}>{title}</Typography>
        <Typography sx={{fontSize: '13.5px', color: '#6B7280', lineHeight: 1.6, mb: 2.5, flex: 1}}>{body}</Typography>
        <Box sx={{borderTop: '1px solid #F3F4F6', pt: 2}}>
            <Typography sx={{fontSize: '13px', color: '#374151'}}>
                <strong style={{color: NAVY}}>Do it with:&nbsp;</strong>{withText}
            </Typography>
        </Box>
    </Box>
);

const ActionPlanPage = () => (
    <IndividualDashboardShell skipNoDataGate>
        <PageHeader
            title="My Recommended Actions"
            subtitle="What should I do next?"
        />

        <Grid container spacing={2.5} alignItems="stretch">
            {ACTIONS.map((a) => (
                <Grid item xs={12} md={4} key={a.num}>
                    <ActionCard {...a}/>
                </Grid>
            ))}
        </Grid>

        <Box sx={{
            mt: 3, border: '1px solid #C7D9E8', borderLeft: `4px solid ${NAVY}`, borderRadius: '8px',
            backgroundColor: 'var(--brand-surface-subtle, #F0F6FB)', p: 2.5,
        }}>
            <Typography sx={{fontSize: '13.5px', color: '#374151', lineHeight: 1.7, fontWeight: 600}}>
                Pick one to start this week. Every small step builds stronger, safer online habits.
            </Typography>
        </Box>
    </IndividualDashboardShell>
);

export default ActionPlanPage;
